import { number, object, string } from "yup";
import { LIB_PHONE_NUMBER_TYPES, NAME_POLICY_REGEX } from "app/constants";

// Chargé dynamiquement : phoneUtils embarque react-phone-number-input/max (~300 KB metadata)
// qui ne doit pas atterrir dans le bundle initial.
export const validatePhoneNumberType = async (phoneNumberIntl, possibleTypes) => {
	if (typeof phoneNumberIntl !== "string") {
		return true; // if user wants to empty his number input it can be undefined
	}
	const { validatePhoneIntl } = await import("app/utils/phoneUtils");
	return validatePhoneIntl(phoneNumberIntl, possibleTypes);
};

export const defaultValues = {
	"honorific-prefix": "",
	"family-name": "",
	"given-name": "",
	birthdateDay: "",
	birthdateMonth: "",
	birthdateYear: "",
	nationality: "",
	"address-line1": "",
	"address-line2": "",
	"postal-code": "",
	"address-level2": "", // city
	"country-name": "",
	phone: "",
	// TODO SMS-OPTIN
	// phonemobile: "",
};

export const validationSchema = object().shape({
	"family-name": string()
		.min(2, { id: "error.lastName.minlength" })
		.test("nameRegex", { id: "error.lastName.invalid" }, value => {
			if (value && value.length > 0) {
				return (
					!NAME_POLICY_REGEX.SPECIAL_CHAR.test(value) &&
					!NAME_POLICY_REGEX.DIGIT.test(value)
				);
			}
			return true;
		}),
	"given-name": string()
		.min(2, { id: "error.firstName.minlength" })
		.test("nameRegex", { id: "error.firstName.invalid" }, value => {
			if (value && value.length > 0) {
				return (
					!NAME_POLICY_REGEX.SPECIAL_CHAR.test(value) &&
					!NAME_POLICY_REGEX.DIGIT.test(value)
				);
			}
			return true;
		}),
	birthdateDay: number().test("birthdateDay", { id: "error.birthdate.day" }, function (value) {
		const { birthdateMonth, birthdateYear } = this.parent;
		if (birthdateMonth !== undefined || birthdateYear !== undefined) {
			return value !== undefined;
		}
		return true;
	}),
	birthdateMonth: number().test(
		"birthdateMonth",
		{ id: "error.birthdate.month" },
		function (value) {
			const { birthdateDay, birthdateYear } = this.parent;
			if (birthdateDay !== undefined || birthdateYear !== undefined) {
				return value !== undefined;
			}
			return true;
		}
	),
	birthdateYear: number().test("birthdateYear", { id: "error.birthdate.year" }, function (value) {
		const { birthdateDay, birthdateMonth } = this.parent;
		if (birthdateDay !== undefined || birthdateMonth !== undefined) {
			return value !== undefined;
		}
		return true;
	}),
	phone: string()
		.test("phone (mobile or a fixed-line number)", { id: "error.phone.invalid" }, numberIntl =>
			validatePhoneNumberType(numberIntl)
		)
		.when("sms", {
			is: true,
			then: schema =>
				schema
					.required({
						id: "error.phone.when.sms.is.activated",
					})
					.test(
						"should be a mobile phone number",
						{ id: "error.phone.when.sms.is.activated" },
						numberIntl =>
							validatePhoneNumberType(numberIntl, [
								LIB_PHONE_NUMBER_TYPES.PERSONAL_NUMBER,
								LIB_PHONE_NUMBER_TYPES.MOBILE,
							])
					),
		}),
});
